import { usePrivy } from "@privy-io/react-auth";
import { FrontDoor } from "../components/FrontDoor";
import { useSession } from "../session/SessionContext";

/**
 * The 403 screen, which is really the onboarding screen.
 *
 * Signing in is what makes this person grantable: the session fires the auth
 * bootstrap on refusal, which creates their user row and captures their email,
 * and admins grant by email. So there is nothing to copy and nothing to paste;
 * the only instruction that matters is "ask an admin", and the email shown is
 * the one the admin should be told. Anything phrased as a failure would be
 * telling a new operator they did something wrong.
 */
export function AccessRefused() {
  const { logout, refresh } = useSession();
  const { user } = usePrivy();
  const email = user?.email?.address ?? null;

  return (
    <FrontDoor
      title="You do not have access yet"
      actions={
        <>
          <button type="button" onClick={logout}>
            Sign out
          </button>
          <button type="button" className="primary" onClick={refresh}>
            Check again
          </button>
        </>
      }
    >
      <p className="subtle">
        Ask an admin to add you to the console
        {email ? (
          <>
            {" "}
            (they can grant access to <strong>{email}</strong>)
          </>
        ) : null}
        , then reload this page.
      </p>
    </FrontDoor>
  );
}
